import { createFileRoute } from "@tanstack/react-router";
import { FestivalPage, buildHomeHead } from "@/components/festival/Page";

export const Route = createFileRoute("/")({
  head: () => buildHomeHead("nl"),
  component: Index,
});

function Index() {
  return <FestivalPage lang="nl" />;
}
